import request from '@/utils/request'

//一览
export function getpositionList(data) {
  return request({
    url: '/positionList/getpositionList',
    method: 'post',
    data
  })
}

//删除
export function deleteposition(data) {
  return request({
    url: '/positionList/updateIsDeleted',
    method: 'post',
    data
  })
}

//单个查询
export function getpositionListByid(data) {
  return request({
    url: '/positionList/getpositionListByid',
    method: 'get',
    params: data
  })
}

//新增
export function save(data) {
  return request({
    url: '/positionList/save',
    method: 'post',
    data
  })
}

//新增
export function update(data) {
  return request({
    url: '/positionList/update',
    method: 'post',
    data
  })
}

//根据名称模糊查询职位
export function selectPosition(data) {
  return request({
    url: '/positionList/selectPosition',
    method: 'post',
    params: data
  })
}
